/** Must match PortalAPI `PortalAPI/api/applications/utils/stageIds.js` PROCESSOR_IDS.TURNKEY */
export const TURNKEY_PROCESSOR_ID = '776650a8-ae8e-42b8-95d0-f230b68779b3'
